module.exports = __webpack_public_path__ + "img/park.8e5d7e42.png";